import InputElement from 'Components/Element/InputElement';
import FormErrorBanner from 'Components/Element/FormErrorBanner';
import React, { useState } from 'react'
import ReactModal from 'react-modal'

function OrgChangeCode({uploadNew, onClose, confirmCode, resendCode, apiError, setApiError, confirmationCode, setConfirmationCode}) {
    
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30
        },
        content: {
            zIndex: 30,
            height: 'auto',
            width: 'auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >    
        <div className="w-96 h-auto p-5 mt-5">
           
           <div className='w-full'>
               <p className="mb-6 text-sky-600  flex items-center justify-center font-bold">Enter code sent to your new work email address you have entered to continue with submission of details to admin.</p>
               <FormErrorBanner>{apiError}</FormErrorBanner>
           
               <InputElement
                   handleChange={(e) => setConfirmationCode(e.target.value)}
                   label = "Confirmation code"
                   labelStyle={" font-bold"}
                   handleFocus={() => setApiError("")}
                   name = "code"
                   placeholder= "******"
                   value = {confirmationCode}
               />
               
               <div 
                   className={" cursor-pointer w-full h-10 bg-sky-500  text-white rounded mt-5 flex justify-center items-center " + (confirmationCode ? " bg-sky-500" : " bg-gray-300 opacity-50 ")}
                   onClick={confirmCode}
                   >
                       Verify
               </div>
               <div className=" flex justify-between cursor-pointer mt-5 font-normal text-sm">
               <div onClick={resendCode} className="underline underline-offset-2 font-bold decoration-sky-500">Resend code </div>

               </div>  
           </div>
       </div> 
    </ReactModal>
  )
}

export default OrgChangeCode